import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { Card, CardActions, CardContent } from "@mui/material";

export const TooltipCard = styled(Card)`
  max-width: 460px;
  position: relative;
  border-radius: 0.5rem;

  ${(p) => p.theme.media.mobileDown} {
    max-width: 90vw;
  }
`;
export const CustomCardContent = styled(CardContent)`
  padding: 1.5rem;
  padding-right: 4rem;
  padding-bottom: 1rem;
  h5 {
    font-weight: 600;
  }
  p {
    margin-top: 1rem;
    font-size: ${(p) => p.theme.text.fontSizes.l};
  }
`;
export const CustomCardActions = styled(CardActions)`
  padding: 1.5rem;
  justify-content: flex-end;
`;
export const CardActionsButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;
export const CloseButton = styled(IconButton)`
  position: absolute !important;
  right: 1rem;
  top: 1rem;
`;
